import { render, staticRenderFns } from "./openAcctDc.vue?vue&type=template&id=18ba457e&scoped=true"
import script from "./openAcctDc.vue?vue&type=script&lang=js"
export * from "./openAcctDc.vue?vue&type=script&lang=js"
import style0 from "./openAcctDc.vue?vue&type=style&index=0&id=18ba457e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ba457e",
  null
  
)

export default component.exports